import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import WebsiteLayout from '../components/WebsiteLayout';
import Reveal from '../components/Reveal';
import { useLanguage } from '../../../hooks/useLanguage';

interface NewsEntry {
  dateEn: string;
  dateNl: string;
  titleEn: string;
  titleNl: string;
  descEn: string;
  descNl: string;
  href: string;
  ctaEn?: string;
  ctaNl?: string;
}

const ENTRIES: NewsEntry[] = [
  {
    dateEn: '2026 · feature',
    dateNl: '2026 · feature',
    titleEn: 'AI Hub Oost: Thoughtful Oasis makes AI understandable and auditable for the public sector.',
    titleNl: 'AI Hub Oost: Thoughtful Oasis maakt AI begrijpelijk én controleerbaar voor de publieke sector.',
    descEn:
      'AI Hub Oost features Thoughtful Oasis on how we make AI understandable and auditable for the public sector.',
    descNl:
      'AI Hub Oost belicht Thoughtful Oasis over hoe we AI begrijpelijk én controleerbaar maken voor de publieke sector.',
    href: 'https://www.aihub-oost.nl/projects/thoughtful-oasis-maakt-ai-begrijpelijk-en-controleerbaar-voor-de-publieke-sector',
  },
  {
    dateEn: '2026 · report',
    dateNl: '2026 · rapport',
    titleEn: 'AI & Open Overheid: research report.',
    titleNl: 'AI & Open Overheid: onderzoeksrapport.',
    descEn:
      'Platform AI & Overheid (Ministerie BZK / IMI) maps which AI applications around Open Government exist, whether they can handle Woo requests faster and better, and which are ready to scale. Our work on Terminal WOO is referenced.',
    descNl:
      'Platform AI & Overheid (Ministerie BZK / IMI) brengt in kaart welke AI-toepassingen rond open overheid bestaan, of ze Woo-verzoeken sneller en beter aankunnen, en welke klaar zijn om op te schalen. Ons werk aan Terminal WOO wordt genoemd.',
    href: 'https://platformaioverheid.nl/wp-content/uploads/2026/02/Resultaten_onderzoek_AI_en_Open_Overheid_februari_2026_def.pdf',
  },
  {
    dateEn: '2025 · recognition',
    dateNl: '2025 · erkenning',
    titleEn: "EIT: AI Founders Club recognised in the European Commission's Apply AI Strategy.",
    titleNl: 'EIT: AI Founders Club erkend in de Apply AI Strategy van de Europese Commissie.',
    descEn:
      "EIT covers the European Commission's recognition of the AI Founders Club in its Apply AI Strategy. Thoughtful Oasis is named in the cohort for interpretable, auditable RAG via ontological vector databases.",
    descNl:
      'EIT bericht over de erkenning door de Europese Commissie van de AI Founders Club in hun Apply AI Strategy. Thoughtful Oasis wordt genoemd in de cohort voor interpreteerbare, auditeerbare RAG via ontologische vectordatabases.',
    href: 'https://www.eit.europa.eu/news-events/news/ai-founders-club-recognised-european-commissions-apply-ai-strategy',
  },
  {
    dateEn: '2025 · hackathon',
    dateNl: '2025 · hackathon',
    titleEn: 'ECP: Terminal WOO hackathon recap.',
    titleNl: 'ECP: terugblik Terminal WOO hackathon.',
    descEn:
      "ECP's recap of the two-day Open Government hackathon (31 Oct – 1 Nov 2025) where ten teams built solutions to make the Woo process workable and efficient for civil servants.",
    descNl:
      'Terugblik van ECP op de tweedaagse Open Government hackathon (31 okt – 1 nov 2025) waar tien teams oplossingen bouwden om het Woo-proces werkbaar en efficiënt te maken voor ambtenaren.',
    href: 'https://ecp.nl/terugblikhackathonterminalwoo/',
  },
  {
    dateEn: '2025 · feature',
    dateNl: '2025 · feature',
    titleEn: 'Vakblad Od: How do you improve the Woo process?',
    titleNl: 'Vakblad Od: hoe verbeter je het Woo-proces?',
    descEn:
      'Editie 49 of Vakblad Od covers the hackathon winner: an AI chatbot helping citizens sharpen their information question before filing a formal Woo request.',
    descNl:
      'Editie 49 van Vakblad Od bespreekt de winnaar van de hackathon: een AI-chatbot die burgers helpt hun informatievraag aan te scherpen voordat ze een formeel Woo-verzoek indienen.',
    href: 'https://magazines.od-online.nl/od-editie-49/hackathon-hoe-verbeter-je-het-woo-proces',
  },
  {
    dateEn: '2025 · press',
    dateNl: '2025 · pers',
    titleEn: 'Platform AI & Overheid: Terminal WOO post.',
    titleNl: 'Platform AI & Overheid: Terminal WOO-post.',
    descEn: 'Platform AI & Overheid shares Terminal WOO as an example of AI applied to the Woo process.',
    descNl: 'Platform AI & Overheid deelt Terminal WOO als voorbeeld van AI toegepast op het Woo-proces.',
    href: 'https://www.linkedin.com/posts/ai-aienoverheid-terminalwoo-share-7436812252386709504-E-I5/',
  },
  {
    dateEn: '2025 · press',
    dateNl: '2025 · pers',
    titleEn: 'NL Startup Competition: Failing, learning, building.',
    titleNl: 'NL Startup Competition: falen, leren, bouwen.',
    descEn: 'NL Startup Competition features Rens Dommerholt on the journey of building Thoughtful Oasis.',
    descNl: 'NL Startup Competition belicht Rens Dommerholt over het opbouwen van Thoughtful Oasis.',
    href: 'https://www.linkedin.com/posts/nl-startup-competition_failing-learning-and-building-rens-domerholt-activity-7424731020505272320-502K',
  },
  {
    dateEn: '2025 · press',
    dateNl: '2025 · pers',
    titleEn: 'EIT AI Community: Founders Club spotlight.',
    titleNl: 'EIT AI Community: Founders Club spotlight.',
    descEn: 'EIT AI Community spotlight on Thoughtful Oasis joining the Founders Club cohort.',
    descNl:
      'EIT AI Community zet Thoughtful Oasis in het zonnetje naar aanleiding van toetreding tot de Founders Club-cohort.',
    href: 'https://www.linkedin.com/posts/eit-ai-community_eitcommunity-activity-7381938999072018432-3Em4/',
  },
  {
    dateEn: '2025 · press',
    dateNl: '2025 · pers',
    titleEn: 'EIT AI Community: follow-up post.',
    titleNl: 'EIT AI Community: opvolgpost.',
    descEn: 'A follow-up from EIT AI Community on Thoughtful Oasis.',
    descNl: 'Een opvolgpost van EIT AI Community over Thoughtful Oasis.',
    href: 'https://www.linkedin.com/feed/update/urn:li:activity:7406966416001769472/',
  },
  {
    dateEn: '2025 · case',
    dateNl: '2025 · case',
    titleEn: 'Novel-T: Search technology for complex queries.',
    titleNl: 'Novel-T: zoektechnologie voor complexe vragen.',
    descEn:
      "Novel-T case study on Thoughtful Oasis: search technology for situations where users don't know exactly what they are looking for in large databases.",
    descNl:
      'Novel-T casestudie over Thoughtful Oasis: zoektechnologie voor situaties waarin gebruikers niet precies weten waar ze in grote databases naar op zoek zijn.',
    href: 'https://novelt.com/nl/cases/244/thoughtful-oasis',
  },
  {
    dateEn: '2025 · listing',
    dateNl: '2025 · vermelding',
    titleEn: 'Dutch AI Startup Map: listed.',
    titleNl: 'Dutch AI Startup Map: vermeld.',
    descEn: 'Thoughtful Oasis listed on the Dutch AI Startup Map (entry STU_241).',
    descNl: 'Thoughtful Oasis vermeld op de Dutch AI Startup Map (entry STU_241).',
    href: 'https://dashboard.dutchstartup.ai/dashboard?s=STU_241',
    ctaEn: 'View →',
    ctaNl: 'Bekijk →',
  },
];

const News: React.FC = () => {
  const [language] = useLanguage();
  const en = language === 'en';

  const customCta = (
    <div className="site-end__cta">
      <span className="site-end__label">{en ? 'Talk to us' : 'Praat met ons'}</span>
      <h2 className="site-end__title">
        {en
          ? "Have news from us in your inbox: drop a note and we'll add you."
          : 'Nieuws van ons in je inbox? Stuur een berichtje, we zetten je erop.'}
      </h2>
      <div className="site-end__action">
        <Link className="btn btn-primary" to="/contact">
          {en ? 'Contact us' : 'Neem contact op'}
        </Link>
      </div>
    </div>
  );

  return (
    <WebsiteLayout customCta={customCta} hidePartners>
      <Helmet>
        <title>News · Thoughtful Oasis</title>
        <meta
          name="description"
          content="Announcements, press and milestones from Thoughtful Oasis: the lab and the company."
        />
        <link rel="canonical" href="https://thoughtful-oasis.com/news" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="News · Thoughtful Oasis" />
        <meta
          property="og:description"
          content="Announcements, press and milestones from Thoughtful Oasis: the lab and the company."
        />
        <meta property="og:url" content="https://thoughtful-oasis.com/news" />
        <meta property="og:image" content="https://thoughtful-oasis.com/assets/website/photos/og-home.jpg" />
      </Helmet>

      <header className="hero hero--sub">
        <div className="hero__inner">
          <span className="label">{en ? 'News' : 'Nieuws'}</span>
          <h1 style={{ marginTop: 20 }}>
            {en ? 'Announcements, press, and milestones.' : 'Aankondigingen, pers en mijlpalen.'}
          </h1>
          <p className="hero__sub">
            {en ? (
              <>
                Short updates from the lab and the company. For research publications, see{' '}
                <Link className="link-inline" to="/research">
                  research
                </Link>
                . For pilots and live cases, see{' '}
                <Link className="link-inline" to="/applications">
                  cases
                </Link>
                .
              </>
            ) : (
              <>
                Korte updates uit het lab en het bedrijf. Voor onderzoekspublicaties zie{' '}
                <Link className="link-inline" to="/research">
                  onderzoek
                </Link>
                . Voor pilots en live cases zie{' '}
                <Link className="link-inline" to="/applications">
                  toepassingen
                </Link>
                .
              </>
            )}
          </p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <Reveal className="section-head">
            <span className="label">Recent</span>
            <h2 style={{ marginTop: 18 }}>
              {en ? '2026 to date.' : '2026 tot nu toe.'}
            </h2>
          </Reveal>

          <div className="news-list">
            {ENTRIES.map((entry, idx) => (
              <Reveal key={idx} className="news-list__item">
                <span className="news-list__date">{en ? entry.dateEn : entry.dateNl}</span>
                <div>
                  <p className="news-list__title">{en ? entry.titleEn : entry.titleNl}</p>
                  <p className="news-list__desc">{en ? entry.descEn : entry.descNl}</p>
                </div>
                <a
                  className="btn btn-secondary"
                  href={entry.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {en ? entry.ctaEn || 'Read →' : entry.ctaNl || 'Lees →'}
                </a>
              </Reveal>
            ))}
          </div>

          <p
            className="body-text"
            style={{
              margin: '56px auto 0',
              maxWidth: 'var(--max-w-prose)',
              padding: '0 var(--pad-x)',
              textAlign: 'center',
            }}
          >
            {en ? 'Press inquiries: ' : 'Persvragen: '}
            <Link className="link-inline" to="/contact?prefill=press">
              {en ? 'contact us' : 'neem contact op'}
            </Link>
          </p>
        </div>
      </section>
    </WebsiteLayout>
  );
};

export default News;
